<template>
    <ui-modal size="large" ref="modal" title="In-Tray">
        <div class="container">
            <div class="row justify-content-end">
                    <ui-button
                        type="secondary"
                        @click="selectAll"
                        color="primary"
                        icon="select_all"
                        size="small"
                    >Select All</ui-button>
            </div>
            <hr>
            <div class="row align-items-center">
                <template>
                    <ui-tabs ref="tabs" @tab-change="tabChanged" :fullwidth="true" background-color="clear">
                        <ui-tab ref="all" title="New Files">
                            <document-list 
                                :documents="documents"
                                :is-loading="isLoading"
                                @select="select"
                            />
                        </ui-tab>
                        <ui-tab ref="trash" title="Recently Deleted">
                            <document-list 
                                :documents="documents"
                                :is-loading="isLoading"
                                @select="select"
                            />
                        </ui-tab>
                    </ui-tabs>
                </template>
            </div>
        </div>
        <div slot="footer">
            <div v-if="tab !== 'trash'">
                <ui-button :disable="this.isDeleting" @click="choose" color="primary" :disabled="0 === numberSelected">Choose {{ numberSelected }} files</ui-button>
                <ui-button :loading="this.isDeleting" @click="trash" :disabled="0 === numberSelected">Delete selected files</ui-button>
            </div>
            <div v-else>
                <ui-button :disabled="isEmptyingTrash || 0 === numberSelected" :loading="isRestoring" @click="restoreSelected">Restore selected files</ui-button>
                <ui-button :disabled="isRestoring || 0 === this.documents.length" :loading="isEmptyingTrash" color="red" @click="emptyTrash">Empty Trash</ui-button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { DocumentResource } from '../../classes/Api/Document'
    import DocumentList from './InTrayDocumentList'

    export default {
        components: { DocumentList },
        props: {
            documentType: {
                type: String,
                default: '*'
            }
        },
        data() {
            return {
                documents: [],
                isLoading: true,
                tab: null,
                isEmptyingTrash: false,
                isDeleting: false,
                isRestoring: false
            }
        },
        computed: {
            selectedDocuments() {
                return this.documents.filter(document => document.selected)
            },
            numberSelected() {
                return this.selectedDocuments.length
            },
            hasDocuments() {
                return this.documents.length > 0
            }
        },
        methods: {
            open() {
                this.load();

                this.$refs.modal.open()
            },
            tabChanged(tab) {
                let param = {}

                this.tab = param.show = tab.$vnode.data.ref

                this.load(param)
            },
            load(param) {
                this.isLoading = true

                this.documents = []

                param = Object.assign({ type: this.documentType }, param)

                DocumentResource.unassociated(param).then(response => {
                    this.documents = response.data.map(document => {
                        document.selected = false
                        return document
                    })
                    this.isDeleting = false
                    this.isLoading = false
                    this.isRestoring = false
                })
            },
            select(document) {
                document.selected = !document.selected
            },
            selectAll() {
                this.documents.map(d => {
                    this.select(d)
                })
            },
            choose() {
                this.$emit('selected', this.selectedDocuments)
                this.$refs.modal.close();
            },
            emptyTrash() {
                this.isEmptyingTrash = true
                DocumentResource.emptyTrash().then(() => {
                    this.documents = []
                    this.isEmptyingTrash = false
                })
            },
            trash() {
                let promises = []

                this.isDeleting = true

                for (let i in this.selectedDocuments) {
                    promises.push(DocumentResource.destroy(this.selectedDocuments[i].uuid));
                }

                Promise.all(promises).then(() => {
                    this.load();

                    this.$emit('trash-emptied')
                })
            },
            restoreSelected() {
                let promises = []

                this.isRestoring = true

                for (let i in this.selectedDocuments) {
                    promises.push(DocumentResource.restore(this.selectedDocuments[i].uuid));
                }

                Promise.all(promises).then(() => {
                    let tabId = this.$refs.tabs.tabs[0].id

                    this.$refs.tabs.setActiveTab(tabId)

                    this.$emit('restored')
                })
            }
        }
    }
</script>